
import { api } from "./axios";
import { makeFilterString } from './utils';

export async function createNewModels(data) {
    let res = await api.post("models/store", data);
    if (res) return res.data.data;
    else return false;
}
export async function updateModels(id, data) {
    let res = await api.post("models/update/" + id, data);
    if (res) return res.data.data;
    else return false;
}
export async function getAllModels(objFilter) {
    let res = await api.get("models/getAll/" + makeFilterString(objFilter));
    if (res) return res.data.data;
    else return false;
}
export async function getModelDetails(id) {
    let res = await api.get("website/models/show/" + id);
    if (res) return res.data.data;
    else return false;
}


export async function deleteModels(id) {
    let res = await api.get("models/destroy/" + id);
    if (res) return res.data.data;
    else return false;
}

export async function updateAllModelsInBrand(id, data) {
    let res = await api.post("models/updateBrandModels/" + id, data);
    if (res) return res.data.data;
    else return false;
}